import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomDropDown from '../../shared-components/custom-drop-down/CustomDropDown';
// import PageTitle from '../../shared-components/page-title/PageTitle';

import AccountLevel from './components/AccountLevel';
import PlatformLevel from './components/PlatformLevel';

/**
 * Fee configuration component
 * @returns
 */
function FeeConfiguration() {
  const { t, i18n } = useTranslation('sharedComponent');

  return (
    <div className="fee-configuration-wrap" dir={i18n.dir()}>
      {/* <PageTitle title="Fee Configuration" /> */}
      <div className="fee-configuration">
        <CustomDropDown label={t('platformLevel')} content={<PlatformLevel />} open />
        <CustomDropDown label={t('accountLevel')} content={<AccountLevel />} open />
      </div>
    </div>
  );
}

export default FeeConfiguration;
